<template>
    <div>
        <div class="modal-close-btn-point">
            <div class="modal-close-btn-container" v-on:click="$emit('close')">
                <SVGModalClose/>
            </div>
        </div>
        <div class="modal-title-big">
            Выберете категорию
        </div>
        <vue-custom-scrollbar class="category-list">
            <div class="custom-categories-table-row custom-head-row modal-categories">
<!--                <div class="custom-categories-table-label">№</div>-->
                <div class="custom-categories-table-label">Название</div>
                <!--                <div class="custom-categories-table-label">Изображение</div>-->
                <div class="custom-categories-table-label">Выбрать</div>
            </div>
            <ProductCategoriesRecursive :canChooseAny="canChooseAny" :categories="categories"/>
        </vue-custom-scrollbar>
    </div>
</template>

<script>
import ProductCategoriesRecursive from "./ProductCategoriesRecursive";
import SVGModalClose from "../../../SVG/SVGModalClose";
import vueCustomScrollbar from 'vue-custom-scrollbar';


export default {
    name: "ProductCategories",
    components: {
        SVGModalClose,
        ProductCategoriesRecursive,
        vueCustomScrollbar
    },
    props:['valueUpdated', 'canChooseAny'],
    computed: {
        categories() {
            return this.$store.getters["adminPanel/categories/SELF"];
        }
    },
}
</script>

<style scoped>
    .category-list {
        height: calc(100% - 110px);
        margin: 0 10px;
        /* height: 100%; */
        overflow: auto;
        position: absolute;
    }

    /*.modal-categories{*/
    /*    grid-template-columns: max-content auto 60px;*/
    /*}*/
</style>
